import { Translator } from '../../utils/translate';
import { Logo } from '../Logo/Logo';
import s from './Header.scss';
import { MainMenu } from './Navigation/MainMenu';
import { NavigationStructure } from '../../data/types';
import { HFConfig } from '../../config';

interface HeaderProps {
  t: Translator;
  structure: NavigationStructure;
  config: HFConfig;
}

const Header = ({ t, structure, config }: HeaderProps) => {
  return `
    <header class="${s.container}" id="WIX_HEADER" data-wix-header="hf2020">
      <div class="${s.header}">
        ${Logo({ t })}
        ${MainMenu({ navigation: structure, t, config })}
      </div>
    </header>
  `;
};

export default Header;
